import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { List, Map } from 'immutable';
import { applyMiddleware, compose, createStore } from 'redux';
import { assertModuleSanity } from './assertModuleSanity';
import { combineReducersMap } from './composeReducer';
import { composeAppCoreModule } from './core';
/**
 * Middleware to enable the redux devtools chrome extension.
 * https://github.com/zalmoxisus/redux-devtools-extension
 */

var reduxDevtools = process.env.NODE_ENV !== 'test' && !(process.versions && process.versions.node) && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

function combineModuleReducers(modules) {
  var moduleReducerMap = modules.filter(function (mod) {
    return mod.state;
  }).map(function (mod) {
    return mod.state;
  }).reduce(function (list, state) {
    return list.concat(state);
  }) // flatten via reduce because immutable flatten loses type information
  .reduce(function (reducers, _ref) {
    var branchKey = _ref.branchKey,
        reducer = _ref.reducer;
    return Object.assign(reducers, _defineProperty({}, branchKey, reducer));
  }, {});
  return combineReducersMap(moduleReducerMap, combineModuleInitialStates(modules));
}

function selectModuleEffects(modules) {
  return modules.filter(function (mod) {
    return mod.effects;
  }).map(function (mod) {
    return mod.effects;
  }).reduce(function (list, effectGroup) {
    return list.concat(effectGroup);
  }, List()).map(function (effectGroup) {
    return Map(effectGroup).valueSeq().toList();
  }).reduce(function (list, effects) {
    return list.concat(effects);
  }, List()).reduce(function (allEffects, effect) {
    return allEffects.set(effect.effectType, effect);
  }, Map());
}

export function combineModuleInitialStates(modules) {
  return modules.filter(function (mod) {
    return mod.state;
  }).map(function (mod) {
    return mod.state;
  }).reduce(function (list, state) {
    return list.concat(state);
  }) // flatten via reduce because immutable flatten loses type information
  .reduce(function (initialState, mod) {
    return initialState.set(mod.branchKey, mod.initialState);
  }, Map());
}

function selectModuleMiddleware(modules) {
  return modules.map(function (mod) {
    return mod.middleware;
  }).reduce(function (list, state) {
    return list.concat(state);
  });
}

function selectModuleStoreEnhancers(modules) {
  return modules.map(function (mod) {
    return mod.storeEnhancers;
  }).reduce(function (list, state) {
    return list.concat(state);
  });
}

function selectModuleSubscribers(modules) {
  return modules.map(function (mod) {
    return mod.subscribers;
  }).reduce(function (list, state) {
    return list.concat(state);
  });
}

function composeMiddlewareAndEnhancers(modules) {
  if (reduxDevtools) {
    return compose.apply(void 0, [applyMiddleware.apply(void 0, _toConsumableArray(selectModuleMiddleware(modules)))].concat(_toConsumableArray(selectModuleStoreEnhancers(modules)), [reduxDevtools]));
  }

  return compose.apply(void 0, [applyMiddleware.apply(void 0, _toConsumableArray(selectModuleMiddleware(modules)))].concat(_toConsumableArray(selectModuleStoreEnhancers(modules))));
}

export function createStoreWithModules(modulesToLoad) {
  var userModules = modulesToLoad.reduce(function (modsAndDeps, mod) {
    return modsAndDeps.concat(mod.dependencies).push(mod);
  }, List()).toSet().groupBy(function (m) {
    return m.name;
  }).reduce(function (moduleList, moduleGroup) {
    if (!moduleGroup.first().combine) {
      return moduleList.push(moduleGroup.first());
    }

    return moduleList.push(moduleGroup.first().combine(moduleGroup.first(), moduleGroup.map(function (mod) {
      return mod.params;
    }).toList()));
  }, List()).toArray();
  var modules = [composeAppCoreModule(selectModuleEffects(userModules))].concat(_toConsumableArray(userModules));

  if (process.env.NODE_ENV === 'test') {
    var _require = require('./testModule'),
        composeAppTestModule = _require.composeAppTestModule; //tslint:disable-line:no-require-imports


    modules.push(composeAppTestModule);
  }

  assertModuleSanity(modules);
  var store = createStore(combineModuleReducers(modules), combineModuleInitialStates(modules), composeMiddlewareAndEnhancers(modules));
  selectModuleSubscribers(modules).forEach(function (subscriber) {
    return store.subscribe(function () {
      return subscriber.onChange(subscriber.selector(store.getState()));
    });
  });
  return store;
}